export const FETCH_NODES_LIST = 'FETCH_NODES_LIST';
export const FETCH_FORMS = 'FETCH_FORMS';
export const FETCH_HISTORY_ITEMS = 'FETCH_HISTORY_ITEMS';
export const FETCH_PROPERTIES_LIST = 'FETCH_PROPERTIES_LIST';
export const RENAME_GROUP_TITLE = 'RENAME_GROUP_TITLE';
export const ADDTOBUILDER_NODES = 'ADDTOBUILDER_NODES';
export const UPDATE_DRAG_NODE = 'UPDATE_DRAG_NODE';
export const UPDATE_INDIVIDUAL_NODE = 'UPDATE_INDIVIDUAL_NODE';
export const UPDATE_NODES = 'UPDATE_NODES';
export const CLEANUP_ON_UNMOUNT = 'CLEANUP_ON_UNMOUNT';
export const UPDATE_CHILDREN_VALUE = 'UPDATE_CHILDREN_VALUE';
export const GET_IMPORTED_QUERY = 'GET_IMPORTED_QUERY';
export const CLEAR_NODES_LIST_UPDATE_HIDDEN_LIST = 'CLEAR_NODES_LIST_UPDATE_HIDDEN_LIST';
export const MERGE_DRAG_NODES = 'MERGE_DRAG_NODES';
export const UPDATE_FORMS = 'UPDATE_FORMS';
export const SET_SEARCH_SECTION_PANEL_STATE = 'SET_SEARCH_SECTION_PANEL_STATE';

export const SEARCH_SECTION_TABS = ['Fields', 'Forms'];
